import { css, cx, mediaQueries } from '@eti/styles';
import { forwardRef } from 'react';
import { analytics } from '@eti/utils';
import { productWrapperStyles } from '../../main-layout/styles';
import Header from '../../main-layout/header/Header';
import Body from '../../main-layout/body/Body';
import ProductCardContextProvider from '../../context/ProductCardContext';
import { bindCoreComponents, renderCoreComponents, sortCoreComponents } from '../../utils/product-layout-utils';
import ButtonContainer from '../../main-layout/cta-components/ButtonContainer';
import SmallCardReadMore from './SmallCardReadMore';
import { jsx as _jsx } from "react/jsx-runtime";
export const smallCardGrid = css`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(4, auto);
  padding: 16px;
  row-gap: 8px;

  .illustration {
    grid-area: 1 / 1 / 5 / 2;
  }

  .header {
    grid-area: 1 / 2 / 2 / 3;
    padding: 0;

    .pictogram {
      display: grid;
      grid-area: 2 / 1 / 3 / 2;
    }

    .title {
      align-items: flex-start;
      grid-area: 2 / 2 / 3 / 3;
    }
  }

  .body {
    grid-area: 2 / 2 / 3 / 3;
    margin-inline-start: 40px;
    margin-top: -14px;
    padding: 0;

    .description {
      line-height: 1.4;
      margin-bottom: 0;

      .link {
        display: inline;
      }
    }
  }

  .readMore {
    grid-area: 3 / 2 / 4 / 3;
    margin-inline-start: 40px;
    padding: 0;

    @media ${mediaQueries.small.only} {
      margin-inline-start: 0;
    }
  }

  .cta {
    grid-area: 4 / 2 / 5 / 3;
    padding: 0;

    .selection {
      grid-area: 1 / 2 / 2 / 3;
      margin-bottom: 2px;

      @media ${mediaQueries.small.only} {
        margin-bottom: 4px;
      }
    }

    &:not(:has(legend)) {
      @media ${mediaQueries.small.only} {
        .buttonWrapper {
          margin-top: 22px;
        }
      }

      .priceLabel {
        margin-top: 8px;
      }
    }

    .children {
      display: contents;
    }

    @media ${mediaQueries.small.only} {
      grid-column-gap: 0;
      grid-template-columns: 0 1fr;
    }
  }
`;
const smallProductCardCoreComponents = {
  Header,
  Body,
  ReadMore: SmallCardReadMore,
  Cta: ButtonContainer
};
const SmallCardLayout = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    customGrid,
    productData,
    className,
    coreComponentsRenderConfig
  } = _ref;
  analytics.useLogMouseFlowTagEffect('Small card');
  const {
    productName,
    isHighlighted,
    productId
  } = productData;
  const sortedCoreComponents = sortCoreComponents(SmallCardLayout, coreComponentsRenderConfig);
  return /*#__PURE__*/_jsx(ProductCardContextProvider, {
    productData: productData,
    children: /*#__PURE__*/_jsx("div", {
      className: cx(productWrapperStyles(isHighlighted), className, customGrid !== null && customGrid !== void 0 ? customGrid : smallCardGrid),
      "data-offer-rate": productId,
      "data-testid": `${productName}-container`,
      ref: ref,
      children: renderCoreComponents(sortedCoreComponents, children)
    })
  });
});
export default bindCoreComponents(SmallCardLayout, smallProductCardCoreComponents);
//# sourceMappingURL=NewSmallCardLayout.js.map